module.exports = __webpack_public_path__ + "img/logo-normal.7429dc2a.png";